import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { Text } from "ui/Typography"
import IconWithBg from "ui/IconWithBg"
import { getJournalIcon } from "pagesV2/pro/Calendar/utils"

const GridHeaderCell = ({ day, dayStr, journalNoteDates, hasJournalPermission, isActive, onJournalClick, thClassName }) => {
  const handleJournalClick = isActive ? () => onJournalClick(dayStr) : undefined

  return (
    <th className={thClassName}>
      <Flex vertical align="center" gap={2}>
        <Text fw="500">{day.format("ddd D")}</Text>
      </Flex>
      {hasJournalPermission && (
        <Flex justify="center" className="mt-xxs">
          <IconWithBg
            disabled={!isActive}
            icon={getJournalIcon(journalNoteDates, dayStr)}
            onClick={handleJournalClick}
          />
        </Flex>
      )}
    </th>
  )
}

GridHeaderCell.propTypes = {
  day: PropTypes.object.isRequired,
  dayStr: PropTypes.string.isRequired,
  journalNoteDates: PropTypes.array,
  hasJournalPermission: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  onJournalClick: PropTypes.func.isRequired,
  thClassName: PropTypes.string,
}

export default GridHeaderCell
